import { Spacing, MediaQueries } from 'UI'

export default theme => ({
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: ({ isMobile }) => isMobile ? 'rgba(0,0,0)' : 'rgba(0,0,0,.92)',
    zIndex: 99999,
    display: 'flex',
    overflow: 'auto',
    alignItems: 'flex-start'
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  closeIcon: {
    color: theme.neutral[400],
    fontSize: 16,
    marginBottom: 12,
    textAlign: 'right',
    '& > *': {
      cursor: 'pointer',
      lineHeight: 1
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  image: {
    borderRadius: 4,
    cursor: 'pointer',
    filter: 'brightness(0.5)'
  },
  view: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: 17,
    alignItems: 'center',
    backgroundColor: ({ isMobile }) => !isMobile ? theme.neutral[400] : 'none',
    borderRadius: '0px 0px 4px 4px !important',
    padding: ({ isMobile }) => !isMobile ? Spacing(0, 4, 4, 4) : Spacing(0, 0, 4, 0)
  },
  cardStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  sliderHeader: {
    backgroundColor: theme.neutral[400],
    padding: Spacing(0, 4),
    marginBottom: '0 !important'
  },
  container: {
    padding: Spacing(5, 0)
  },
  [`${MediaQueries.mobile}`]: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: Spacing(5, 0)
    }
  },
  [`${MediaQueries.tablet}`]: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: Spacing(5, 0)
    }
  },
  selectedProjectStyle: {
    filter: 'brightness(1)'
  },
  socialMediaContainer: {
    width: '100%',
    margin: () => Spacing(4, 0, 0, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
})
